// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f425229c","977":"a0a96a1d"}[chunkId] + ".chunk.js";
};